import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  authApiClient,
  bxApiClient,
} from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const getGLCode = async (
  queryParams?: Record<string, any>
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "gl-code-settings",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toString());
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          qs.push(key, value.toString());
        }
      });
    }
  );

  const response = await bxApiClient.get(url);
  return response.data?.result;
};

export const updateGlCode = async (payload: any) => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `gl-code-settings`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toString());
    }
  );
  const response = await bxApiClient.put(url, payload);
  return response.data?.result;
};

export const getUtilityServices = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "auth",
    `utility/services`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await authApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    id: item.name,
    name: item.name,
  }));
};

export const getSummary = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `gl-codes-settings/summary`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await authApiClient.get(url);

  const data = response.data?.result;
  return data;
};
